
import { Component, Mixins, Watch } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import scroll from '@/mixins/scroll';
import { handleFill, imagePreview } from '@/utils/util';
import { getStoreInfo } from '@/api/ccx'

@Component({
  name: 'ApplyCCXStoreDetails'
})
export default class ApplyCCXStoreDetails extends Mixins(scroll) {
  @Getter companyId!: string;

  handleFill = handleFill
  imagePreview = imagePreview

  active = 0;
  tabList = [
    {
      name: '店铺基本信息',
      id: 0,
    },
    {
      name: '收款账户信息',
      id: 1,
    },
    {
      name: '绑定供应商',
      id: 2,
    },
  ];
  detailData: any = {}; // 详情数据

  // 账户类型（回显）
  get banTypeText() {
    const { bankType = 1 } = this.detailData
    return bankType == 1 ? '公司账户' : '私人账户'
  }

  created() {
    // 获取店铺详情数据
    getStoreInfo({ storeId: this.companyId }).then(res => {
      let storeData = res?.data || {}
      const { pickupStartTime, pickupEndTime, takeStartTime, takeEndTime } =
        storeData
      // 去掉时间字符串中的秒
      const formatTime = (time) => time?.replace(/:00$/, '') || ''
      storeData = {
        ...storeData,
        pickupStartTime: formatTime(pickupStartTime),
        pickupEndTime: formatTime(pickupEndTime),
        takeStartTime: formatTime(takeStartTime),
        takeEndTime: formatTime(takeEndTime)
      }
      this.detailData = storeData
      // 更新店铺信息
      this.$store.commit('SET_CCX_STORE', storeData)
    })
  }

  onEdit() {
    this.$router.push({
      path: '/editCCXStore'
    })
  }
}
